import { Chip } from "@mui/material";
import { useTranslation } from "i18n-fe";

// #1761 / #3564 — the ONE visible RO/ROO indicator, shared by every surface
// that names a class. An FVD ride-out/split section carries the SAME
// classNumber/className as its base class, so without this chip the two
// render as identical "223. <name>" entries and a scribe can silently work
// the wrong one (CDS prod, CNO 462). The chip shows ONLY when staff flagged
// the class with the explicit `splitSection: true` (Score Admin, #3564):
// never inferred from the class name or the sngClassID decimal. Renders
// NOTHING for any other class, so callers drop it in unconditionally. Theme
// tokens only (never MUI `primary`, dark grey and invisible against grey.900
// in dark mode, #862).
export default function SplitClassChip({
  klass,
  testId = "split-class-chip",
  sx,
}) {
  const { t } = useTranslation("score");
  if (klass?.splitSection !== true) return null;
  return (
    <Chip
      size="small"
      variant="outlined"
      label={t("classes.splitSection")}
      data-testid={testId}
      sx={{ color: "text.primary", borderColor: "text.secondary", ...sx }}
    />
  );
}
